// extracted by mini-css-extract-plugin
export default {"radio":"styles_radio__pMUlz","radio-disabled":"styles_radio-disabled__pFmWd","text":"styles_text__-T5T8","input":"styles_input__ghpNN","group":"styles_group__0O-tk"};